import React, { useEffect, useContext } from "react";
import { ChatbotContext } from "../../context/ChatbotContext";
import { useLanguage } from "../../context/LanguageContext";

const QuickReply = ({ reply, click, isRiasecQuickReplies }) => {
  const { setDisabledInput, setIsVisibleInput } = useContext(ChatbotContext);
  const { language } = useLanguage(); // Get current language

  useEffect(() => {
    if (!isRiasecQuickReplies) {
      setDisabledInput(true);
      setIsVisibleInput(false);
    }
  }, []);

  // Get the original text from Dialogflow with error handling
  let replyText = '';
  let payloadValue = '';
  
  try {
    if (reply && reply.structValue && reply.structValue.fields) {
      replyText = reply.structValue.fields.text?.stringValue || '';
      payloadValue = reply.structValue.fields.payload?.stringValue || '';
    }
  } catch (error) {
    console.error('Error parsing quick reply data:', error);
    console.log('Reply object:', reply);
    return null; // Don't render if we can't parse the data
  }
  
  // If we don't have valid text, don't render
  if (!replyText) {
    return null;
  }

  // Adjust "Yes/No" based on the selected language
  if (language === "fil") {
    if (replyText.toLowerCase() === "yes") {
      replyText = "Oo";
    } else if (replyText.toLowerCase() === "no") {
      replyText = "Hindi";
    }
  } else if (language === "en") {
    if (replyText.toLowerCase() === "oo") {
      replyText = "Yes";
    } else if (replyText.toLowerCase() === "hindi") {
      replyText = "No";
    }
  }

  const isRecommendedButton =
    replyText.trim().toLowerCase() === "recommended degree programs";

  return (
    <a
      href="/"
      className="btn btn-outline-primary message-quick-reply-btn m-1 rounded-pill px-3"
      id={isRecommendedButton ? "qr-recommended-degree-programs" : undefined}
      onClick={(e) => click(e, payloadValue, replyText)}
    >
      {replyText}
    </a>
  );
};

export default QuickReply;
